export enum MiPlatformSignalREventNames {
  UserUpdated = "UserUpdateEvent",
  AttemptUpdated = "AttemptUpdated",
  AutoAssignStatusUpdated = "AutoAssignStatusUpdated",
  GlobalMessageReceived = "GlobalMessageReceived",
}
